module.exports = __webpack_public_path__ + "05_long_black.9aec2d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_long_black.png
// module id = h+QQ
// module chunks = 0